<template>
  <div class="calculator-page">
    <calc-seo-intro path="/calculators/participation" />
    <participation-roi-calculator :calculatorTitle="'Participation ROI'" />
  </div>
</template>

<script>
import ParticipationRoiCalculator from "../components/ParticipationROICalculator.vue";
import CalcSeoIntro from "../components/CalcSeoIntro.vue";

export default {
  name: "ParticipationROI",
  components: {
    ParticipationRoiCalculator,
    CalcSeoIntro,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/app.scss';

.calculator-page {
  width: 100%;
  min-height: calc(100vh - 120px);
}
</style>
